module.exports = __webpack_public_path__ + "static/media/danxuanfuxuan.dab72da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/vehicleInquiry/inputPage/images/danxuanfuxuan.png
// module id = 1594
// module chunks = 0